import type { EntityConfig } from "@/v2/framework/registry/types";
import { createMarketGroupsView } from "./grid/view";

export default {
  id: "market-groups",
  name: "market-groups",
  title: "metadata.market_groups",
  position: 9,
  create: (ctx) => createMarketGroupsView(ctx),
} satisfies EntityConfig;
